import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/66c82458-e626-46d7-957c-10a5451851e4";
export const REGISTER_URL = "https://a.ntrk2.com/867e9107-dacd-4f67-bbc5-66c232f94ebd";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://pkplus.kzw2a.com/download?openExternalBrowser=1&id=85vnzfsl0mpl8oz";

export * from "./codes";
export * from "./context";
